import {Col, Row} from "antd";
import styled from "styled-components";

export const InputRowContainer = styled(Row)`
    padding-left: 40px;
    width: 100%;
`;

export const InputRowTitle = styled(Col)`
    font-size: 18px;
`;
